import { useContext } from 'react'
import { GameContext } from '../GameContextF.jsx'
import { Ptext } from '../../../componentsF/Chakra3F/ChakraF.jsx'
import { getMyTurnRemainDur, shouldNagPlayer } from '../../sharedF/getMyTurnRemainDurF.mjs'
import { useNow } from '../../../componentsF/hooksF/useNowF.jsx'
import { gameStateMsToLux } from '../../sharedF/gameStateMsToLuxAI.mjs'

export const NagArea = (props) => {
  const {myState: {publicState}, publicStates, settings} = useContext(GameContext)
  const {myTaskName, gameActiveAt} = gameStateMsToLux(publicState)
  const {now} = useNow()

  if (!gameActiveAt) return null
  if (settings?.disableTurnTimers) return null
  if (!shouldNagPlayer({ activePlayerCount: Object.keys(publicStates).length })) return null

  const {maxTurnDur, elapsedDur, remainDur} = getMyTurnRemainDur({myTaskName, gameActiveAt, now})

  if (elapsedDur.as('minutes') > maxTurnDur.as('minutes') / 2) return <Ptext {...{...props}}>
    {remainDur.as('minutes') > 0 ? `Remaining Time ${remainDur.toFormat('mm:ss')}` : `Time is up. Submit ASAP!`}
    {/* 03:48 */}
    {/* {waitingNames.join(', ')} are waiting on you! */}
  </Ptext>
}